import {Injectable} from '@angular/core';
import {ApiService} from '@xref/ngx';
import {Subject} from 'rxjs';

@Injectable()
export class EmployerDetailsService {
    data: any = {};
    dataUpdated$ = new Subject();

    constructor(
        private api: ApiService
    ) {}

    hasData(): boolean {
        return this.data.hasOwnProperty('company_name');
    }

    // @success <optional>: A success method parsed from the caller to be executed in that context
    // @error <optional>: An error method parsed from the caller to be executed in that context
    getEmployerDetails(success: any = () => {}, error: any = () => {}, force = false): void {
    // Take the success parsed into the function, perform local logic first then parsed success
        const successWrapped = (data: any) => {
            this.data = this.reduce(data.data);
            this.dataUpdated$.next(true);
            success(this.data);
        };

        // Take the error parsed into the function, perform local logic first then parsed success
        const errorWrapped = (err: any) => {
            error(err);
        };

        if (!this.hasData() || force) {
            this.api.get(`settings/employer-details`).subscribe(successWrapped, errorWrapped);
        } else {
            success(this.data);
        }
    }

    private reduce(data: any): any {
        const reducedData: any = {};
        Object.assign(reducedData, data);
        return reducedData;
    }
}
